module.exports = __webpack_public_path__ + "img/C6.6749b34b.svg";